module.exports = __webpack_public_path__ + "static/img/tx.af0539fc.png";